<template>
  <div id="all auth-page password-recovery">
    <div id="ajax-upload">
      <main id="main">
        <div class="container">
          <div class="auth-box">
            <div class="logo">
              <IconLogo/>
            </div>
            <div class="auth-form">
              <p class="h2 title line ">404 Page not Found</p>
              <p>
                <a :href="getLink">Go Home </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import IconLogo from "./common/icons/IconLogo";
import {toggleBodyClass} from "../common"
import {mapState, mapActions} from  "vuex"

export default {
    name: 'NotFound',
    components: {IconLogo},
    computed: {
        ...mapState('user', [
            'roles',
            'username'
        ]),
        getLink() {
            if (this.roles.includes('dev') || this.roles.includes('admin')) {
                return '/admin'
            } else if (this.roles.includes('manager')) {
                return '/manage/requests'
            }

            return '/';
        }
    },
    methods: {
        ...mapActions('user', [
            'getUserInfo',
        ]),
    },

    mounted() {
        this.getUserInfo();
        toggleBodyClass('addClass', 'auth-page');
        toggleBodyClass('addClass', 'password-recovery');
    },
    unmounted() {
        toggleBodyClass('removeClass', 'auth-page');
        toggleBodyClass('removeClass', 'password-recovery');
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
